import { render, staticRenderFns } from "./SimpleErrorModal.vue?vue&type=template&id=df2edd8a&scoped=true&"
import script from "./SimpleErrorModal.vue?vue&type=script&lang=js&"
export * from "./SimpleErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleErrorModal.vue?vue&type=style&index=0&id=df2edd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2edd8a",
  null
  
)

export default component.exports